<template>
  <v-col>
    <v-snackbar v-model="snackbarErro" color="error" top centered timeout="10000">
      {{ mensagemSnackbarErro }}
    </v-snackbar>
    <v-form v-model="isValido">
      
      <v-card class="" elevation="0" max-width="">
        <v-card-title>
          <span class="text-h6 font-weight-light pl-md-4 pt-md-5">| Relatório de Solicitações de Itens </span>
        </v-card-title>
        
        <v-card-text>
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-autocomplete label="Selecionar Unidade" :items="listUnidade" v-model="formRelatorio.numeroUnidade" prepend-icon="mdi-domain" name="unidade" :rules="[requerido('uma unidade')]"></v-autocomplete>
            </v-col>
            
            <v-col cols="12">
              <v-autocomplete label="Selecionar Produto" :items="listItem" v-model="formRelatorio.numeroItem" prepend-icon="mdi-package-variant-closed"></v-autocomplete>
            </v-col>
            
            <v-col cols="6">
              <v-menu ref="menuDe" v-model="menuDe" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto" :rules="[required('uma data')]">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateFormattedDe" label="De" prepend-icon="mdi-calendar" v-bind="attrs" @blur="dateDe = parseDate1(dateFormattedDe)" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dateDe" no-title @input="menuDe = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu ref="menuAte" v-model="menuAte" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto" :rules="[required('uma data')]">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateFormattedAte" label="Até" prepend-icon="mdi-calendar" v-bind="attrs" @blur="dateAte = parseDate2(dateFormattedAte)" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dateAte" no-title @input="menuAte = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
      
      <v-col cols="12" align="center">
        <v-btn :disabled="btnRelatorio" width="300" color="#3cbc62" class="white--text text-center" @click="gerarRelatorio()">
          GERAR RELATORIO
        </v-btn>
        <v-snackbar v-model="snackbar" :timeout="timeout">
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="green" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-card>
  </v-form>
    
    <Loading :open="loading" />
    
    <FormRelatorio :isTheModalOpen="formRelatorio.isOpen" :modalTitleToolbar="formRelatorio.modalTitleToolbar" v-on:fecharModal="formRelatorioClose" v-on:generate-excel="generateExcel()">
      <v-row v-if="infoRelatorio.length > 0">
        <v-col cols="12">
          <v-list>
            <v-list-group v-for="(relatorio, i) in infoRelatorio" :key="i" no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ relatorio.nomeEndereco }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item>
                <v-list-item-content class="pa-4">
                  <v-card class="pa-md-3" elevation="4">
                    <v-card-title class="headline">
                      <v-icon large left>
                        mdi-chart-bar
                      </v-icon>
                      <span class="text-h6 font-weight-medium">Gráfico dos Produtos</span>
                    </v-card-title>
                    <v-card-text>
                      <Bar height="100%" :chartData="relatorio.graficoRelatorioSolicitacaoItem" :options="optionsBar"></Bar>
                    </v-card-text>
                  </v-card>

                  <v-card class="mt-md-3 pa-md-3" elevation="4">
                    <v-card-title>
                      <v-icon large left>
                        mdi-archive
                      </v-icon>
                      <span class="text-h6 font-weight-medium">Pedido dos Produtos</span>
                    </v-card-title>
                    <v-card-text>
                      <DataTable :tableTitle="'Lista de Pedidos'" :tableHeader="headersPedidos" :tableRows="relatorio.listRelatorioSolicitacaoItem"></DataTable>
                    </v-card-text>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-card class="pa-md-3" elevation="4">
            <v-card-title class="headline">
              <span class="text-h6 font-weight-medium">Dados insuficientes</span>
            </v-card-title>
            <v-card-text>
              <span class="text-subtitle-1 font-weight-light">Não é possível de visualizar o gráfico ou a lista de itens solicitados, pois, não há dados suficientes.</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </FormRelatorio>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import FormRelatorio from "../components/FormRelatorio";
import DataTable from "../components/DataTable2.vue";
import Bar from "@/components/Charts/Bar";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import colorPattern from "@/utils/colorPattern.js";
import validation from "@/utils/validation.js";

export default {
  components: {
    Loading,
    FormRelatorio,
    DataTable,
    Bar,
  },

  computed: {
    computedDateFormatted1() {
      return this.formatDate1(this.dateDe);
    },
    computedDateFormatted2() {
      return this.formatDate2(this.dateAte);
    },
  },

  watch: {
    isValido() {
      this.btnRelatorio = !this.isValido;
    },
    dateDe() {
      this.dateFormattedDe = this.formatDate1(this.dateDe);
      this.formRelatorio.dataInicio = this.dateDe;
    },
    dateAte() {
      this.dateFormattedAte = this.formatDate2(this.dateAte);
      this.formRelatorio.dataFim = this.dateAte;
    },
  },

  data: () => ({
    ...validation,
    //Configs para Gráfico
    options: {
      legend: {
        display: true,
        position: "right",
      },
    },
    optionsBar: {
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },

    //Header Tabela Pedido
    headersPedidos: [
      {
        text: "Número",
        value: "numeroItem",
      },
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Qtde Solicitada",
        value: "quantidadeSolicitacaoItem",
      },
      {
        text: "Unidade",
        value: "nomeEndereco",
      },
      {
        text: "Data Pedido",
        value: "dataSolicitarItem",
      },
      {
        text: "Status",
        value: "indicadorStatusSolicitarItem",
      },
    ],

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //Para o back
    formRelatorio: {
      isOpen: false,
      numeroUnidade: null,
      numeroItem: null,
      dataInicio: null,
      dataFim: null,
      modalTitleToolbar: "Relatório de Solicitações de Produtos",
    },

    //Lista dos autocomplete
    listUnidade: [],
    listItem: [],

    //Snackbar
    snackbar: false,
    text: "Relatorio gerado com sucesso!",
    timeout: 2000,
    snackbarErro: false,
    mensagemSnackbarErro: null,
    loading: false,

    //DatePicker
    dateDe: null,
    dateAte: null,
    dateFormattedDe: null,
    dateFormattedAte: null,
    menuDe: false,
    menuAte: false,
    isValido: false,
    btnRelatorio: true,

    //Array de dados que foram gerados apartir do relatorio
    infoRelatorio: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    formatDate1(dateDe) {
      if (!dateDe) return null;

      const [year, month, day] = dateDe.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate1(dateDe) {
      if (!dateDe) return null;

      const [day, month, year] = dateDe.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },

    formatDate2(dateAte) {
      if (!dateAte) return null;

      const [year, month, day] = dateAte.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate2(dateAte) {
      if (!dateAte) return null;

      const [day, month, year] = dateAte.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },

    async initialize() {
      try {
        await this.getUnidade();
        await this.getItem();
      } catch (error) {
        console.log(error);
      }
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    async getUnidade() {
      const responseEnderecos = await axios.get("enderecoordemservico", this.config);

      this.listUnidade = responseEnderecos.data.map((row) => {
        return {
          value: row.numeroEnderecoOrdemServico,
          text: row.nomeEndereco,
        };
      });
    },

    async getItem() {
      const responseItem = await axios.get("itemSistema", this.config);

      this.listItem = responseItem.data.map((row) => {
        return {
          value: row.numeroItemSistema,
          text: row.nomeItemSistema,
        };
      });
    },

    async gerarRelatorio() {
      this.loading = true;
      try {
        this.snackbarErro = false;
        this.formRelatorio.dataInicio = this.dateDe;
        this.formRelatorio.dataFim = this.dateAte;

        const responseRelatorio = await axios.put("/relatorioSolicitarItem", this.formRelatorio, this.config);

        responseRelatorio.data.map((relatorioSelecionado, index) => {
          relatorioSelecionado.graficoRelatorioSolicitacaoItem.datasets[0].backgroundColor.push(colorPattern[index]);

          relatorioSelecionado.listRelatorioSolicitacaoItem.map((itemSelecionado) => {
            itemSelecionado.dataSolicitarItem = this._formatStringInBrazilianDateFormat(itemSelecionado.dataSolicitarItem);
          });
        });

        this.infoRelatorio = responseRelatorio.data.filter((relatorioSelecionado) => relatorioSelecionado.listRelatorioSolicitacaoItem.length > 0);
        this.loading = false;
        this.formRelatorio.isOpen = true;
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.snackbarErro = true;
        this.mensagemSnackbarErro = error.response.data.message;
      }
    },

    formRelatorioClose() {
      this.formRelatorio.numeroUnidade = null;
      this.formRelatorio.numeroItem = null;
      this.formRelatorio.dataInicio = null;
      this.dateDe = null;
      this.dateAte = null;
      this.dateFormattedDe = null;
      this.dateFormattedAte = null;
      this.formRelatorio.dataFim = null;
      this.formRelatorio.isOpen = false;
    },

    //#region GERAR EXCEL
    async generateExcel() {
      try {
        const workbook = new Workbook();

        await Promise.all(
          this.infoRelatorio.map((relatorioSelecionado) => {
            var worksheet = workbook.addWorksheet(relatorioSelecionado.nomeEndereco, { properties: { tabColor: { argb: "FF00FF00" } }, views: [{ showGridLines: false }] });

            worksheet.columns = [
              { key: "col1", width: 25 },
              { key: "col2", width: 25 },
              { key: "col3", width: 25 },
              { key: "col4", width: 25 },
              { key: "col5", width: 25 },
            ];

            const colNumeroItem = worksheet.addRow({
              col1: "ID",
              col2: "Quantidade Solicitada",
              col3: "Endereço",
              col4: "Data Solicitada",
              col5: "Status do Produto",
            });
            colNumeroItem.font = { bold: true };

            relatorioSelecionado.listRelatorioSolicitacaoItem.map((solicitarItem) => {
              worksheet.addRow({
                col1: solicitarItem.numeroItem,
                col2: solicitarItem.quantidadeSolicitacaoItem,
                col3: solicitarItem.nomeEndereco,
                col4: solicitarItem.dataSolicitarItem,
                col5: solicitarItem.indicadorStatusSolicitarItem,
              }).alignment = { vertical: "top", horizontal: "left" };
            });

            //STYLE BORDER
            var borderStyles = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            worksheet.eachRow({ includeEmpty: true }, function(row) {
              row.eachCell({ includeEmpty: true }, function(cell) {
                cell.border = borderStyles;
              });
            });
          })
        );

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "relatorio-solicitações-de-itens.xlsx");
        });
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion
  },
};
</script>
